module.exports = __webpack_public_path__ + "static/img/20018 (1).db97d58.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20018 (1).webp
// module id = cUS2
// module chunks = 14